import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import logo from "./logo_vertical.png"

const Login = ({ loginUser }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const history = useHistory();

  useEffect(() => {
    if (isLoggedIn) history.push("/admin/dashboard/posts");
  });

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !pass) {
      return toast.warning("Please fill in all fields");
    } else {
      loginUser(email, pass);
    }
  };

  return (
    <div className="container" style={{minHeight: "750px"}}>
      <div className="row">
        <div className="col-md-12">
          <h1 className="text-center mt-5 pb-1 pt-2 ">
          <img
            className="img mt-2" height={"150 px"}
            src={logo}
          />
            <span className="text-primary"></span>
          </h1>
          <h2 className="text-center pt-2">Login</h2>
          <div className="col-md-4 p-2 mt-3 mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="email"
                  className="form-control" style={{borderRadius: "100px"}}
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  className="form-control" style={{borderRadius: "100px"}}
                  placeholder="Password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                />
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-block" style={{backgroundColor: "#1AC5D9", borderRadius: "100px", color: "white"}}>
                  Login
                </button>
              </div>
            </form>
            {/* <Link to="/register" className="btn btn-block btn-primary" style={{borderRadius: "100px", color: "white"}}>
              Register
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
